module.exports = __webpack_public_path__ + "static/media/white.3abe0700.PNG";